import React from "react";
import "./Havel.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Moselleimages from "../../Media/Citraland Kedamaian/Moselle/Moselle";
import Britzimages from "../../Media/Citraland Kedamaian/Britz/Britz";

const imageMap = {
  Moselleimages,
  Britzimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Residential" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
